import React from 'react';
import paper from 'paper'
import {Raster, Path, view, project} from 'paper'
import './App.css';

function App() {
  return (
    <div className="App">
      <body className="fullscreen">
      <article>
        <div class="paperscript">
          <div class="canvas">
            <canvas id='paper-canvas' resize='true'/>
          </div>
        </div>
      </article>
      </body>
    </div>
  );
}

window.onload = function() {
  paper.install(window);
  paper.setup('paper-canvas');

  window.document.getElementById('paper-canvas').addEventListener('touchmove', function (event) {
    event.preventDefault();
    return false;
  });

  /// Create a raster item:
  var raster = new Raster('flower.jpg');
  var loaded = false;

  raster.on('load', function() {
    loaded = true;
    onResize();
  });

  // Make the raster invisible:
  raster.visible = false;

  var lastPos = view.center;
  function moveHandler(event) {
    if (!loaded)
      return;
    if (lastPos.getDistance(event.point) < 10)
      return;
    lastPos = event.point;

    console.log(event.point)

    var size = this.bounds.size.clone();
    var isLandscape = size.width > size.height;

    // If the path is in landscape orientation, we're going to
    // split the path horizontally, otherwise vertically:

    //console.log(size);

    if(isLandscape) {
      size.width /= 2;
    } else {
      size.height /= 2;
    }
    //size /= isLandscape ? [2, 1] : [1, 2];

    console.log(size);

    var path = new Path.Rectangle({
      point: this.bounds.topLeft.floor(),
      size: size.ceil(),
      onMouseMove: moveHandler
    });
    path.fillColor = raster.getAverageColor(path);

    path = new Path.Rectangle({
      point: isLandscape
        ? this.bounds.topCenter.ceil()
        : this.bounds.leftCenter.ceil(),
      size: size.floor(),
      onMouseMove: moveHandler
    });
    path.fillColor = raster.getAverageColor(path);

    this.remove();
  }

  function onResize(event) {
    if (!loaded)
      return;

    project.activeLayer.removeChildren();

    // Transform the raster so that it fills the bounding rectangle
    // of the view:
    raster.fitBounds(view.bounds, true);

    // Create a path that fills the view, and fill it with
    // the average color of the raster:
    new Path.Rectangle({
      rectangle: view.bounds,
      fillColor: raster.getAverageColor(view.bounds),
      onMouseMove: moveHandler
    });
  }
};


export default App;
